import { Mesh } from "three";

export const pointObsColor = 0xE6E600;
export const aerialObsColor = 0x62B7B0;
export const imageObsColor = 0x9900CC;
export const flashColor = 0xFFFFFF;

export class ImageObservation extends Mesh {
  constructor(geometry, material) {
    super(geometry, material);
  }
}

export class PointObservation extends Mesh {
  constructor(geometry, material) {
    super(geometry, material);
  }
}
